<div class="tc-select-wallet form-field">
  <div class="tc-form-field size-md">
    <label class="label">{{'REQUEST.WALLET' | translate}}</label>
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="input-field has-select-option"
      (click)="toggle()" tcClickOutSide (clickOutside)="hideList($event)">
      <mat-select [formControl]="walletControl">
      </mat-select>
      <tc-table-loading *ngIf="isLoading else select" type="select"></tc-table-loading>

      <ng-template #select>
        <div class="selected" *ngIf="selected">{{walletControl.value}} <span>({{selected.accountNumber}})</span> </div>
        <!-- <div class="selected" *ngIf="!selected">{{'REQUEST.WALLET' | translate}}</div> -->
      </ng-template>
      @if(hint){
        <mat-hint class="hint-text">
          {{hint}}
        </mat-hint>
      }
    </mat-form-field>
  </div>


  <div class="currency-select">
    <div class="list" [ngClass]="{'hide ': !showList}">
      <div class="item" *ngFor="let item of wallets" (click)="selectItem(item)">
        <div class="info">
          <div>
            <img [src]="item.currencyLightIcon">
            <span>{{item.walletName}}</span>
          </div>

          <span class="account-number">{{item.accountNumber}}</span>
        </div>
        <div class="balance">{{item.balance | tcCurrency: item.precision}} {{item.currencyCode}}</div>
      </div>
    </div>
  </div>
</div>